import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ArrowRightUpIcon,
  CameraTickIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleIcon,
  CloseIcon,
  EditIcon,
  EraseIcon,
  FormalIcon,
  ImageIcon,
  PlayIcon,
  RectangleIcon,
  RedoArrowIcon,
  SaveIcon,
  ShapesIcon,
  StrokeWidthIcon,
  TelevisionIcon,
  TrashIcon,
  UndoArrowIcon,
  VideoIcon,
  ShowIcon,
  SlidesIcon,
  FreedrawIcon,
  LaserIcon,
  RefreshIcon,
  SandglassIcon,
  PauseIcon,
  ArrowLeftIcon,
  ShareIcon,
  MessageCircleIcon,
  PlusIcon,
  SendIcon,
  CopyIcon,
  FolderIcon,
  MenuIcon,
  PlayCircleIcon,
  WarningIcon,
  CutIcon,
  DetailsIcon,
  LogoutIcon,
  ExportIcon,
  UserIcon,
  VideoCutIcon,
  TakeawaysIcon,
  StrategyIcon,
  DecisionPointIcon,
  QuizIcon,
  TranscriptionIcon,
  PlayFilledIcon,
  ShareStrokeIcon,
  Menu04Icon,
  StampIcon,
  VerticalDotsIcon,
  CodeViewIcon,
  DownloadIcon,
  ClockIcon,
  AiIcon,
  UserCheckIcon,
  UserLockIcon,
  RedactionIcon,
  ScreenshotIcon,
  CalendarIcon,
  SecurityIcon,
  AudioIcon,
  LockIcon,
  Menu07Icon,
  BarchartIcon,
  SearchIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  TrashCrossIcon,
  MicrophoneOffIcon,
  MicrophoneIcon,
  HeadphonesIcon,
  LoginIcon,
  SatIcon,
  DesktopIcon,
  WorldIcon,
  AlertCircleIcon,
  CloudIcon,
  CaseLibIcon,
  EquipmentIcon,
  UserCircleIcon,
  WorskspaceIcon,
} from './svg';

@NgModule({
  exports: [
    AiIcon,
    AlertCircleIcon,
    ArrowLeftIcon,
    ArrowRightUpIcon,
    AudioIcon,
    BarchartIcon,
    CalendarIcon,
    CameraTickIcon,
    CaseLibIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CircleIcon,
    ClockIcon,
    CloseIcon,
    CloudIcon,
    CodeViewIcon,
    CopyIcon,
    CutIcon,
    DecisionPointIcon,
    DesktopIcon,
    DetailsIcon,
    DownloadIcon,
    EditIcon,
    EquipmentIcon,
    EraseIcon,
    ExportIcon,
    FormalIcon,
    FolderIcon,
    FreedrawIcon,
    QuizIcon,
    HeadphonesIcon,
    ImageIcon,
    LaserIcon,
    LockIcon,
    LoginIcon,
    LogoutIcon,
    Menu04Icon,
    MenuIcon,
    Menu07Icon,
    MessageCircleIcon,
    MicrophoneIcon,
    MicrophoneOffIcon,
    PauseIcon,
    PlayIcon,
    PlayCircleIcon,
    PlayFilledIcon,
    PlusIcon,
    RectangleIcon,
    RedactionIcon,
    RedoArrowIcon,
    RefreshIcon,
    SandglassIcon,
    SatIcon,
    SaveIcon,
    ScreenshotIcon,
    SearchIcon,
    SecurityIcon,
    SendIcon,
    ShapesIcon,
    ShareIcon,
    ShareStrokeIcon,
    ShowIcon,
    SlidesIcon,
    StampIcon,
    StrategyIcon,
    StrokeWidthIcon,
    TakeawaysIcon,
    TelevisionIcon,
    TranscriptionIcon,
    TrashIcon,
    TrashCrossIcon,
    UndoArrowIcon,
    UserCheckIcon,
    UserCircleIcon,
    UserIcon,
    UserLockIcon,
    VerticalDotsIcon,
    VideoIcon,
    VideoCutIcon,
    WarningIcon,
    WorskspaceIcon,
    WorldIcon,
  ],
  imports: [
    CommonModule,
    AiIcon,
    AlertCircleIcon,
    ArrowLeftIcon,
    ArrowRightUpIcon,
    AudioIcon,
    BarchartIcon,
    CalendarIcon,
    CameraTickIcon,
    CaseLibIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CircleIcon,
    ClockIcon,
    CloseIcon,
    CloudIcon,
    CodeViewIcon,
    CopyIcon,
    CutIcon,
    DecisionPointIcon,
    DesktopIcon,
    DetailsIcon,
    DownloadIcon,
    EditIcon,
    EquipmentIcon,
    EraseIcon,
    ExportIcon,
    FormalIcon,
    FolderIcon,
    FreedrawIcon,
    QuizIcon,
    HeadphonesIcon,
    ImageIcon,
    LaserIcon,
    LockIcon,
    LoginIcon,
    LogoutIcon,
    Menu04Icon,
    MenuIcon,
    Menu07Icon,
    MessageCircleIcon,
    MicrophoneIcon,
    MicrophoneOffIcon,
    PauseIcon,
    PlayIcon,
    PlayCircleIcon,
    PlayFilledIcon,
    PlusIcon,
    RectangleIcon,
    RedactionIcon,
    RedoArrowIcon,
    RefreshIcon,
    SandglassIcon,
    SatIcon,
    SaveIcon,
    ScreenshotIcon,
    SearchIcon,
    SecurityIcon,
    SendIcon,
    ShapesIcon,
    ShareIcon,
    ShareStrokeIcon,
    ShowIcon,
    SlidesIcon,
    StampIcon,
    StrategyIcon,
    StrokeWidthIcon,
    TakeawaysIcon,
    TelevisionIcon,
    TranscriptionIcon,
    TrashIcon,
    TrashCrossIcon,
    UndoArrowIcon,
    UserCheckIcon,
    UserCircleIcon,
    UserIcon,
    UserLockIcon,
    VerticalDotsIcon,
    VideoIcon,
    VideoCutIcon,
    WarningIcon,
    WorskspaceIcon,
    WorldIcon,
  ],
})
export class MibIconsModule {}
